import { resourceReducer } from 'redux-resource';

const resellers = resourceReducer('resellers');

export default resellers;
